import { resolveProgressTexts } from '@/components/Functional/utils/rewardCondition'
import { Typography } from '@/components/UI/Typography'
import type { RewardOverviewData } from '@/schemas/v2/reward'
import { IconChevronRight } from '@tabler/icons-react'
import Link from 'next/link'
import { RewardAcquisitionStatusBadge } from '../RewardAcquisitionStatusBadge'

export type { RewardOverviewData }

type Props = {
  reward: RewardOverviewData
  /** 特典詳細ページへのパス（例: `/uji/rewards/detail?query=1`） */
  href: string
}

export function RewardOverview({ reward, href }: Props) {
  const conditionTexts = resolveProgressTexts(reward.conditions)

  return (
    <Link href={href} className="flex items-start gap-3 px-4 py-3">
      {/* サムネイル */}
      {reward.image ? (
        <img src={reward.image} alt={reward.name ?? ''} className="size-[100px] shrink-0 rounded-[16px] object-cover" />
      ) : (
        <div className="size-[100px] shrink-0 rounded-[16px] bg-gray-100" aria-hidden="true" />
      )}

      {/* テキスト情報 */}
      <div className="min-w-0 flex-1 pt-2">
        <Typography variant="caption1" component="p" c="#000000">
          {reward.name}
        </Typography>
        {reward.acquisitionStatus && (
          <div className="mt-1">
            <RewardAcquisitionStatusBadge status={reward.acquisitionStatus} />
          </div>
        )}
        {conditionTexts.length > 0 && (
          <div className="mt-1 flex flex-col gap-[2px]">
            {conditionTexts.map((text, i) => (
              <p key={i} className="text-[11px] leading-[16px] text-gray-500">
                {text}
              </p>
            ))}
          </div>
        )}
      </div>

      {/* 矢印 */}
      <div className="shrink-0 self-center">
        <IconChevronRight size={24} stroke={1.5} className="text-gray-400" aria-hidden="true" />
      </div>
    </Link>
  )
}
